import store from './store';
import {
  GENERAL_ADMIN,
  DISTRIBUTEUR_ADMIN,
  INDEPENDANT_SHOP_ADMIN,
  CHAIN_SHOP_ADMIN,
  FRANCHISE_SHOP_ADMIN
} from '../constants/admins';
import { ALLSHOP } from '../constants/dataConfig';
import apiService from '@dishopsaas/dishop-backend-api-service'
import { Cookies } from 'react-cookie';
export const getUserPermissions = async (shopId) => {
  const { roleForCompany, shopAdmin: shopWhereTheUserIsAdmin } = await apiService.userGetRoleAndPermissionsForCompany() || {}
  const isSuperAdmin = ['distributeurAdmin', 'companyAdmin'].includes(roleForCompany)
  const isAdminOfThisShop = roleForCompany === 'shopAdmin' && shopWhereTheUserIsAdmin.includes(shopId)
  const allowConnexion = isSuperAdmin || isAdminOfThisShop
  const cookies = new Cookies();
  const expireDate = new Date();
  expireDate.setYear(expireDate.getFullYear() + 1);
  const cookieOptions = { expires: expireDate, path: '/' }
  cookies.set('allowConnexion', allowConnexion, cookieOptions);
  return {
    allowConnexion,
    isAdminOfThisShop,
    isSuperAdmin,
    roleForCompany,
    shopWhereTheUserIsAdmin,
  }
}


export const checkAccess = (type, access) => {
  const {
    generalAdmin,
    distributeurAdmin,
    chainShopAdmin,
    franchiseShopAdmin,
    independantShopAdmin
  } = store.getState().user;
  let allow = false;
  allow = chainShopAdmin ? CHAIN_SHOP_ADMIN[type][access] : allow;
  allow = franchiseShopAdmin && !allow ? FRANCHISE_SHOP_ADMIN[type][access] : allow;
  allow = independantShopAdmin && !allow ? INDEPENDANT_SHOP_ADMIN[type][access] : allow;
  allow = generalAdmin && !allow ? GENERAL_ADMIN[type][access] : allow;
  allow = distributeurAdmin && !allow ? DISTRIBUTEUR_ADMIN[type][access] : allow;
  return allow;
}

export const handleShopsButton = (component, props) => {
  const { shopName } = props;
  const newAccesArray = [];
  newAccesArray.push(shopName);
  if (checkAccess('features', 'globalFinances')) {
    newAccesArray.push(ALLSHOP);
  }
  component.setState({
    accesArray: newAccesArray
  });
}